<template>
  <main v-if="$page">
    <PageHeader :content="$page.header" />
    <ListSection
      :content="$page.strategy"
      list="goals"
      :route="{ to: { name: 'services', hash: '#majoris' } }"
    />
    <ListSection :content="$page.investment" list="products" />
    <ListSection
      :content="$page.planning"
      list="services"
      :link="$page.planning_link"
      :page="$page.planning_page"
    />
    <ImageCTASection
      :content="$page.specialization"
      :link="$page.specialization_link"
      :page="$page.specialization_page"
      reverse
    />
    <QuoteSection
      id="majoris"
      :content="$page.majoris"
      :link="$page.majoris_link"
      :page="$page.majoris_page"
    />
    <CTASection
      :content="$page.perks"
      :link="$page.perks_link"
      :page="$page.perks_page"
      class="--light"
    />
  </main>
</template>

<script>
import CTASection from '@/components/sections/CTASection.vue'
import ImageCTASection from '@/components/sections/ImageCTASection.vue'
import ListSection from '@/components/sections/ListSection.vue'
import PageHeader from '@/components/sections/PageHeader.vue'
import QuoteSection from '@/components/sections/QuoteSection.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Services',
  beetPage: 'services',
  mixins: [PageMetaMixin],
  components: { CTASection, ImageCTASection, ListSection, PageHeader, QuoteSection },
}
</script>
